import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';
import { RegieContext } from '@/contexts';

const CyclesListeTableHeaderImpayes = ({
  regieProlongee,
  actions = null,
  ...rest
}: {
  regieProlongee?: boolean;
  /** Burger d'export du tableau, affiché à droite du libellé « Edition » */
  actions?: React.ReactNode;
  [key: string]: any;
}) => {
  const { regies, selectedRegie } = React.useContext(RegieContext);
  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn =
    _.size(_.find(regies, { identifiant: selectedRegie })?.logicielsFacturier) <= 1;

  return (
    <>
      <ListeTable.Column {...rest} name="dateIncorporation" style={{ width: 150 }}>
        Date
        <br />
        d&apos;incorporation
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="titre" verticalAlign="middle">
        Cycle
        <br />
        et date d&apos;émission
      </ListeTable.Column>
      {!hideSourceColumn && (
        <ListeTable.Column
          {...rest}
          name="logicielFacturier"
          verticalAlign="middle"
          style={{ width: 90 }}
        >
          App
        </ListeTable.Column>
      )}
      <ListeTable.Column {...rest} name="dateLimite" style={{ width: 150 }}>
        Date limite
        <br />
        d&apos;encaissement
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="montant" style={{ width: 110 }} textAlign="right">
        Montant
        <br />
        cycle
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="resteEncaisse" style={{ width: 110 }} textAlign="right">
        Reste
        <br />à encaisser
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="nombreFacturesImpayes" style={{ width: 100 }}>
        Nombre
        <br />
        d&apos;impayés
      </ListeTable.Column>
      {regieProlongee && (
        <ListeTable.Column
          {...rest}
          name="relances"
          verticalAlign="middle"
          textAlign="center"
          style={{ width: 150 }}
        >
          Relance
        </ListeTable.Column>
      )}
      <ListeTable.Column
        {...rest}
        name="etat"
        verticalAlign="middle"
        textAlign="center"
        style={{ width: 125 }}
      >
        Transfert
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="edition"
        verticalAlign="middle"
        textAlign="center"
        style={{ width: 100 }}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          Edition
          {actions}
        </span>
      </ListeTable.Column>
    </>
  );
};

export default CyclesListeTableHeaderImpayes;
